import { GoogleAddress } from "checkout-experience/components/payment-method/pay-options/google/google-pay-payload";
import { AppleAddress } from "checkout-query-client/api/types";
import { BillingFieldNames } from "checkout-query-client/types/chex-form-fields";
import {
  FieldValues,
  PaymentType,
} from "checkout-query-client/types/form-types";
import { isAltPaymentType } from "checkout-query-client/utils/helpers";

import { PostalAddress } from "frontend-client";

export const buildPostalPayload = (
  formFields: Record<string, string>,
  paymentType: PaymentType,
  formId: string
): PostalAddress => {
  const postalAddress = new PostalAddress();
  const isSavedPaymentMethod = paymentType.toString() !== formId;

  if (
    (isSavedPaymentMethod &&
      formFields.currentShippingAddressWithEdit === "true") ||
    (!isSavedPaymentMethod && formFields.doAddressesMatch !== "true")
  ) {
    postalAddress.addressLines = formFields?.billingAddressAddressLine1
      ? [formFields?.billingAddressAddressLine1]
      : [];
    if (formFields?.billingAddressAddressLine2) {
      postalAddress.addressLines.push(formFields?.billingAddressAddressLine2);
    }

    postalAddress.administrativeArea =
      formFields?.billingAddressAdministrativeArea;
    postalAddress.locality = formFields?.billingAddressCity;
    postalAddress.postalCode = formFields?.billingAddressZip;
    postalAddress.regionCode = formFields?.billingAddressCountry;
  }

  postalAddress.recipients =
    paymentType === PaymentType.creditCard
      ? []
      : paymentType === PaymentType.sepa
        ? [formFields?.sepaNameOnAccount]
        : isAltPaymentType(paymentType)
          ? [formFields?.billingAddressName]
          : [formFields?.nameOnAccount];
  return postalAddress;
};

export const buildApplePostalPayload = (
  appleFields: AppleAddress
): PostalAddress => {
  const postalAddress = new PostalAddress();
  postalAddress.addressLines = [
    appleFields.addressLines![0] ?? "",
    appleFields.addressLines![1] ?? "",
  ];
  postalAddress.administrativeArea = appleFields.administrativeArea ?? "";
  postalAddress.locality = appleFields.locality ?? "";
  postalAddress.postalCode = appleFields.postalCode ?? "";
  postalAddress.regionCode = appleFields.countryCode ?? "";
  postalAddress.recipients = [
    `${appleFields.givenName} ${appleFields.familyName}`,
  ];

  return postalAddress;
};

export const buildPostalPayloadFromGooglePay = (
  google?: GoogleAddress
): PostalAddress | undefined => {
  if (!google) return undefined;
  const postalAddress = new PostalAddress();

  postalAddress.addressLines = [
    google.address1 ?? "",
    google.address2 ?? "",
    google.address3 ?? "",
  ];
  postalAddress.postalCode = google.postalCode;
  postalAddress.administrativeArea = google.administrativeArea;
  postalAddress.locality = google.locality;
  postalAddress.regionCode = google.countryCode;

  if (google.sortingCode) {
    postalAddress.sortingCode = google.sortingCode;
  }

  if (google.name) {
    postalAddress.recipients = [google.name];
  }

  return postalAddress;
};

export const buildPostalPayloadFromPaze = (
  formFields?: FieldValues<BillingFieldNames>
): PostalAddress | undefined => {
  if (!formFields) return undefined;
  const postalAddress = new PostalAddress();

  postalAddress.addressLines = formFields?.billingAddressAddressLine1
    ? [formFields?.billingAddressAddressLine1]
    : [];
  if (formFields?.billingAddressAddressLine2) {
    postalAddress.addressLines.push(formFields?.billingAddressAddressLine2);
  }

  postalAddress.administrativeArea =
    formFields?.billingAddressAdministrativeArea ?? "";
  postalAddress.locality = formFields?.billingAddressCity ?? "";
  postalAddress.postalCode = formFields?.billingAddressZip ?? "";
  postalAddress.regionCode = formFields?.billingAddressCountry ?? "";

  return postalAddress;
};
